import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { FnMenuItemState } from '../models/fn-menu.state';
import { FnMenuEventService } from '../service/fn-menu-event.service';
import { FnLocalStorageService } from '../../../services/fn-local-storage.service';

@Component({
	selector: '[fn-menu-item]',
	templateUrl: 'fn-menu.item.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class FnMenuItemComponent extends FnLocalStorageService
	implements OnInit {
	public renderMenuItem: FnMenuItemState;
	@Input() fnMenuItem: FnMenuItemState;

	constructor(private fnMenuService: FnMenuEventService) {
		super();
	}

	ngOnInit() {
		if (this.getItem('selected_menu')) {
			setTimeout(() => {
				this.fnMenuService.onMenuItemClick(this.getItem('selected_menu'),false);
			}, 0);
		}
	}

	menuClickHandler(menuItem: FnMenuItemState) {
		setTimeout(() => {
			this.setItem('selected_menu', menuItem.id);
			this.fnMenuService.onMenuItemClick(menuItem.id);
		}, 0);
	}
}
